<template>
  <v-content id="pages" :class="$vuetify.theme.dark ? undefined : 'grey lighten-3'">
    <v-img src="@/assets/background-geon.jpg" max-height="100vh">
      <v-responsive min-height="100vh" class="align-center d-flex">
        <router-view />
      </v-responsive>
    </v-img>
  </v-content>
</template>

<script>
  export default {
    name: 'PagesCoreView'
  };
</script>
